import { render, staticRenderFns } from "./ScientificDegreeAdd.vue?vue&type=template&id=f574747c&scoped=true&"
import script from "./ScientificDegreeAdd.vue?vue&type=script&lang=js&"
export * from "./ScientificDegreeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f574747c",
  null
  
)

export default component.exports